module.exports = __webpack_public_path__ + "img/re-result-0.52574678.jpg";